import { useState } from 'react';

/** Pages of a fixed size. `reset` wraps a filter's setter so changing the filter goes back to page 1. */
export function usePaging(size: number) {
  const [page, setPage] = useState(1);
  const first = (page - 1) * size;
  return {
    page,
    setPage,
    size,
    reset:
      <T>(set: (v: T) => void) =>
      (v: T) => {
        set(v);
        setPage(1);
      },
    first,
    slice: <R>(rows: R[]) => rows.slice(first, first + size),
  };
}
